import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

import { GraphqlService } from 'src/app/graphql/graphql.service';
import { FeedbackResult, FeedbackType, FeedbackTypeOption } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';

@Component({
	selector: 'pk-broker-feedback-modal',
	templateUrl: './feedback-modal.component.html',
	styleUrls: ['./feedback-modal.component.scss'],
	standalone: false,
})
export class FeedbackModalComponent extends AbstractPageForm {
	// inputs
	public foreignKeyValue: string;
	public feedbackTypeId: number;

	public showSuccess = false;
	public feedbackType: FeedbackType;
	public feedbackResult: FeedbackResult;
	public charactersLeft = 1000;

	constructor(
		public activeModal: BsModalRef,
		private graphqlService: GraphqlService,
		private toastrService: ToastrService,
		private fb: FormBuilder,
	) {
		super();
		this.submitText = 'Submit Feedback';
		this.submitAudit = 'feedback-modal:submit';
	}

	public async loadPageData(): Promise<void> {
		const feedbackTypeResult = await this.graphqlService.getFeedbackModalData(this.feedbackTypeId);
		this.feedbackType = feedbackTypeResult.data.feedbackType;
		this.feedbackType.header = this.feedbackType.header.replace('{username}', this.loggedInUser.fname);
	}

	public getForm() {
		return this.fb.group({
			feedbackTypeOption: [null as FeedbackTypeOption, Validators.required],
			response: ['', [Validators.maxLength(1000)]],
		});
	}

	public async onFormLoaded(): Promise<void> {
		this.form.feedbackTypeOption.valueChanges.subscribe(feedbackTypeOption => {
			if (feedbackTypeOption.showBody) {
				this.form.response.addValidators([Validators.required]);
			} else {
				this.form.response.removeValidators([Validators.required]);
				this.form.response.setValue(feedbackTypeOption.name);
			}
		});
		this.form.response.valueChanges.subscribe(response => {
			this.charactersLeft = 1000 - response.length;
		});
	}

	public async onFormSubmitted(): Promise<void> {
		try {
			await this.graphqlService.upsertFeedbackResult({
				[this.feedbackType.foreignKey]: this.foreignKeyValue,
				feedbackTypeId: this.feedbackTypeId,
				feedbackTypeOptionId: this.form.feedbackTypeOption.value.id,
				response: this.form.response.value,
			});
			this.showSuccess = true;
		} catch (e) {
			this.toastrService.warning('There was a problem submitting your feedback, please try again later.', 'Feedback');
		}
	}

	public close(): void {
		this.activeModal.hide();
	}
}
